import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TableComponent } from '@unilog/ng9-table';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'app-command',
  templateUrl: './command.component.html',
  styleUrls: ['./command.component.scss'],
})
export class CommandComponent implements OnInit {
  article;
  client;
  clientData;
  me;
  searchUser;
  qte = 0;
  data;
  detailsData;
  API_RapportVisiteD;
  listCommandAjout = [];
  @ViewChild('tableComponent', { static: false })
  tableComponent: TableComponent;
  @ViewChild('addCommand', { static: false }) addCommand;
  @ViewChild('details', { static: false }) details;

  constructor(public generalService: GeneralService) {}
  logClient() {
    this.ajouterDocument();
  }
  ngOnInit(): void {}

  ajouterDocument() {
    var document = [
      {
        Tiers_code: this.client,
        Doc_Type: 'CMD',
        Doc_Num: '',
        Doc_ZONE: this.searchUser,
        API_RapportVisiteD: this.API_RapportVisiteD,
      },
    ];

    var documentD = this.listCommandAjout.map((e) => {
      return {
        DocD_Id: '',
        Art_Code: e.Art_Code,
        DocD_Q: e.quantite,
      };
    });

    var ds = {
      Document: document,
      DocumentD: documentD,
      ApiParam: [{ androidId: 123 }],
    };

    this.generalService.saveDA(ds).subscribe(() => {
      this.generalService.dialog.closeAll();
      this.generalService.dialogSuccess('Command ajouter avec success', true);
    });
  }
  ChampEnter() {
    this.generalService
      .getDS('avtclient', this.client)
      .subscribe((res: any) => {
        this.clientData = res.Tiers[0];
      });
  }
  showAddModal() {
    this.generalService.dialog.open(this.addCommand, {
      width: '80%',
    });
  }
  searchCmdsByUsers() {
    // TODO Tbre
    this.generalService
      .rechercheTable('API_CMD', this.searchUser + ',CMD')
      .subscribe((res) => {
        console.log(res);
        this.data = res;
      });
  }
  addNewCommand() {
    this.generalService
      .rechercheTable2('articlef', this.article)
      .subscribe((res) => {
        this.listCommandAjout.push({ ...res[0], quantite: this.qte });
        this.article = null;
        this.qte = null;
      });
  }
  openDetail(docNum) {
    this.generalService
      .rechercheTable2('API_CMDD', docNum)
      .subscribe((res: any) => {
        this.detailsData = res;
        this.generalService.dialog.open(this.details);
      });
  }
  removeCommand(index) {
    this.listCommandAjout.splice(index, 1);
  }
}
